import { computed, inject } from "vue";
import { gbKey } from "@/services/growthbook";

export const useGrowthBookFeatures = () => {
    const growthBook = inject(gbKey, null);

    const isFeatureEnabled = (featureKey: string, defaultValue: boolean): boolean => {
        return growthBook?.isOn(featureKey) ?? defaultValue;
    };

    return {
        isStickyCtaEnabled: computed(() => isFeatureEnabled("sticky-cta", true)),
        redesign_lg_indicative_results202605:
            computed(() => isFeatureEnabled("redesign_lg_indicative_results202605", false)),
    };
};
